<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-row dense align="center" justify="center">
                        <v-col cols="12" sm="3" v-for="(v,k) in listBeneficios" :key="k">
                            <v-row class="ml-3 mr-3">
                                <v-col cols="12">
                                    <v-tooltip top color="secondary" max-width="30%">
                                        <template v-slot:activator="{ on }">
                                            <v-img :src="v.base64" contain height="100" max-height="100" v-on="on"></v-img>
                                        </template>
                                        <p v-html="v.definicion_corta"></p>
                                    </v-tooltip>
                                </v-col>
                                <v-col cols="12" class="text-center">
                                    <span class="body-2 font-weight-bold" v-html="v.beneficio_comp"></span>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>

            <v-row dense class="mt-3 mb-3" align="center" justify="center">
                <v-col cols="12" class="text-center">
                    <v-icon color="secundary" class="btnNext" @click="setStep(5)">arrow_forward</v-icon>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowInformacionBeneficioComplementarioComponent',
        inject:['setData','setStep'],
        props:{
            active:{
                type:Boolean,
                default:false
            },
            listBeneficios:{
                type:Array,
                default: () => []
            },
            parametros:{
                type:Object,
                default:{}
            },
            obBusqueda:{
                type:Object,
                default:{}
            }
        },
        created(){
            this.onListarBeneficioComplementario();
        },
        watch:{
            active(val){
                if(val && _.size(this.listBeneficios) == 0)
                    this.onListarBeneficioComplementario();
            }
        },
        methods:{
            onListarBeneficioComplementario(){
                var error = 'E';
                var o = _.merge({ opcion:'LISTAR_BENEFICIOS_X_CERTIFICADO', id_estado: this.parametros.id_estado_default},
                                _.pick(this.obBusqueda,['idCertificado','idPoliza'])
                                );

                axios.post(`${BASE_URI}administrador/beneficioComplementario/listar`,o)
                     .then((r)=>{
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if(_.size(_.get(r,['data','data'])) == 0){ error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); } 
                            var l = _.cloneDeep(r.data.data);

                            l = _.map(l,(v)=>{
                                    var s = _.split(v.base64,',');
                                    v.base64 = _.includes(v.base64,'data:image/svg') ? `data:image/svg+xml;base64,${s[1]}` : v.base64;
                                    v.valorAsegurado = `$ ${v.valorAsegurado}`;
                                return v;
                            });

                            this.setData('listGeneral.listBeneficios',l);
                     })
                     .catch((e)=>{
                         mensajesAlerta(e,error);
                     });
            }
        }
    }
</script>